import { SupBackdrop } from "@repo/core-ui";
import React, { MouseEvent, useEffect } from "react";

interface LayoutBackdropProps {
  className?: string;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  open?: boolean;
}

export default function LayoutBackdrop({ open, className, onClick }: LayoutBackdropProps) {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

  return <SupBackdrop open={open} portal className={className} onClick={onClick} />;
}
